export default __webpack_public_path__ + "static/media/Windy_04.6dba14f2.png";